module.exports = __webpack_public_path__ + "media/images/athletes/3536-b8b20b9ef7971f34481e84a53395c3e2.png";